import { CancelOptions } from '../constants';
import { SubscriptionScopes } from '../../../types';

export const useCancelAvailableOptions = (
  subscriptionScopes: SubscriptionScopes[]
) => {
  let options: CancelOptions[] = [];
  if (subscriptionScopes.includes('subscription:cancel-immediate')) {
    options.push(CancelOptions.IMMEDIATE_CANCEL);
  }
  if (subscriptionScopes.includes('subscription:cancel-delayed')) {
    options.push(CancelOptions.DELAYED_CANCEL);
  }
  if (subscriptionScopes.includes('subscription:cancel-scheduled')) {
    options.push(CancelOptions.SCHEDULED_CANCEL);
  }
  return options;
};
